import { useCallback } from 'react';

import {
  DecisionRegistryForm,
  getDecisionRegistryEntryFormData,
  submitDecisionRegistryEntry,
} from '~/features/DecisionRegistry/DecisonRegistrySubForm/data';

type PropsType = {
  employeeId: number;
};

/**
 * Decision Registry utility for integrating DR subsection to other forms
 * @param props
 */
export const useDecisionRegistrySubForm = (props: PropsType) => {
  const { employeeId } = props;

  // TODO Continue development, include handling for custom data fields
  const handleSubmitDecisionRegistryEntry = useCallback(
    (data: DecisionRegistryForm) => {
      return submitDecisionRegistryEntry({
        employeeId,
        data: getDecisionRegistryEntryFormData(data),
        customData: undefined,
      });
    },
    [employeeId],
  );

  return {
    handleSubmitDecisionRegistryEntry,
  };
};
